import React, { useContext } from "react";
import { Header as HeaderProps } from "@kameleon-gatsby/gatsby-kameleon-data-source/src/types";
import { BlockType } from "@kameleon-core/types";
import { NavigationContext } from "../util-components/header-provider";
import DynamicLoader from "../util-components/dynamic-loader";

export default function Header(headerProps: HeaderProps) {
  const { isAbsolute } = useContext(NavigationContext);

  const block = headerProps?.block;
  if (!block) return null;

  const layoutProps = block?.blockProps?.layoutProps;
  if (!block?.packageName || block.packageName.trim().length <= 0) return null;
  return (
    <DynamicLoader
      type={BlockType.Header}
      component={block.packageName as string}
      blockProps={{
        ...(block?.blockProps ?? {}),
        layoutProps: {
          ...(layoutProps ?? {}),
          _positionAbsolute: isAbsolute,
        },
      }}
    />
  );
}
